import type TxpDatapoint from 'txp-data/lib/schema/configSchema/TxpDatapoint';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';

export default function populateTxpDataPointObject(
    source: string,
    datapoint: TxpDatapoint
): TxpDatapoint {
    if (!datapoint) {
        datapoint = {};
    }
    datapoint[LogNames.source] = source;
    return datapoint;
}
